<template>
  <div>
    <v-container
      class="full-height"
      fluid
    >
      <import-payroll-salary-increment-import
        v-if="$hasPermissionTo(['import salary increment'])"
        class="mb-2"
      />

      <import-payroll-bank-epf-income-tax-salary-increment-import
        v-if="$hasPermissionTo(['import employee statutory informations'])"
        class="mb-2"
      />

      <import-payroll-employee-contribution-import
        v-if="$hasPermissionTo(['import employee contributions'])"
        class="mb-2"
      />
    </v-container>
  </div>      
</template>
<script>
 
  export default {
    components: {
      ImportPayrollSalaryIncrementImport: () => import('@/components/hris/import/payroll/SalaryIncrementImport'),
      ImportPayrollBankEpfIncomeTaxSalaryIncrementImport: () => import('@/components/hris/import/payroll/bank-epf-income-tax/BankEpfIncomeTax'),
      ImportPayrollEmployeeContributionImport: () => import('@/components/hris/import/payroll/employee-contribution/EmployeeContributionImport'),
    },
  }
</script>
